import { useLocation, Link } from 'react-router-dom';
import { useMemo } from 'react';
import { FaFutbol } from '@react-icons/all-files/fa/FaFutbol';
import { FaTrophy } from '@react-icons/all-files/fa/FaTrophy';
import { FaUsers } from '@react-icons/all-files/fa/FaUsers';
import { FaCrown } from '@react-icons/all-files/fa/FaCrown';

const BASE_TABS = [
  { id: 'apostas', label: 'Apostas', to: '/apostas', match: (p) => p === '/' || p === '/bolao' || p === '/apostas' || p === '/apostas-usuario' || p === '/faq', Icon: FaFutbol },
  { id: 'ranking', label: 'Ranking', to: '/ranking', match: (p) => p === '/ranking', Icon: FaTrophy },
  { id: 'ligas',   label: 'Ligas',   to: '/ligas',   match: (p) => p === '/ligas' || p.startsWith('/liga/'), Icon: FaUsers },
];

const ADMIN_TAB = { id: 'usuarios', label: 'Usuários', to: '/usuarios-bolao', match: (p) => p === '/usuarios-bolao', Icon: FaCrown };

function isAdmin() {
  try {
    return JSON.parse(localStorage.getItem('DATA') || '{}')?.flAdmin === true;
  } catch {
    return false;
  }
}

export default function BottomTabBar() {
  const { pathname } = useLocation();
  const tabs = useMemo(() => (isAdmin() ? [...BASE_TABS, ADMIN_TAB] : BASE_TABS), []);

  // Em páginas não autenticadas (login/register) BottomTabBar não deve aparecer:
  // o Router só monta esse componente dentro de RouterAuth.
  return (
    <nav
      aria-label="Navegação principal"
      className="md:hidden fixed inset-x-0 bottom-0 z-40 bg-white/95 backdrop-blur border-t border-slate-200 pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="flex items-stretch justify-around">
        {tabs.map(({ id, label, to, match, Icon }) => {
          const active = match(pathname);
          return (
            <li key={id} className="flex-1">
              <Link
                to={to}
                className={`flex flex-col items-center justify-center gap-0.5 h-14 text-[11px] font-semibold transition-colors ${
                  active ? 'text-brand-primary' : 'text-slate-500 hover:text-slate-700'
                }`}
                aria-current={active ? 'page' : undefined}
              >
                <Icon className={`text-[20px] ${active ? '' : 'opacity-80'}`} />
                <span>{label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
